export const FETCH_DEFAULT_CARD = 'app/FailedPaymentsModal/FETCH_DEFAULT_CARD';
export const FETCH_DEFAULT_CARD_SUCCESS =
  'app/FailedPaymentsModal/FETCH_DEFAULT_CARD_SUCCESS';
export const FETCH_DEFAULT_CARD_ERROR =
  'app/FailedPaymentsModal/FETCH_DEFAULT_CARD_ERROR';
